import { Button } from 'ui-components';
import { FilterIcon } from 'ui-components/dist/FilterIcon';

import { useContentSearchFilterContext } from '../../ContentSearchFilterContext';
import { useV2ContentFiltersStore } from './useV2ContentFiltersStore';

export function ContentFiltersV2Toggle() {
  const { openGlobalFiltersDrawer } = useV2ContentFiltersStore();
  const { size } = useContentSearchFilterContext();

  return (
    <Button
      onClick={openGlobalFiltersDrawer}
      leftIcon={<FilterIcon boxSize={4} />}
      variant="tertiary"
      className="grow"
      aria-label="Filters"
    >
      Filters{size > 0 ? ` (${size})` : ''}
    </Button>
  );
}
